import { render, staticRenderFns } from "./UpdateThumbnail.vue?vue&type=template&id=023890da"
import script from "./UpdateThumbnail.vue?vue&type=script&lang=js"
export * from "./UpdateThumbnail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports